import { CatHeading } from '@blocks-react/components/Heading';
import { ProductCardFitmentInfoProps } from '../../types';

export const ProductCardFitmentInfo = ({
  children
}: ProductCardFitmentInfoProps) => (
  <CatHeading variant="label-sm">{children}</CatHeading>
);
